import { IModalScope } from "angular-ui-bootstrap";

export interface IRestrictedRoleConfirmationModalScope extends IModalScope {
  confirm(): void;
  cancel(): void;
}

export class RestrictedRoleConfirmationModalCtrl {
  public static $inject = ["$scope"];

  constructor(private $scope: IRestrictedRoleConfirmationModalScope) {
    this.$scope.confirm = this.confirm;
    this.$scope.cancel = this.cancel;
  }

  private confirm = () => {
    this.$scope.$close();
  };

  private cancel = () => {
    this.$scope.$dismiss();
  };
}
